// src/components/auth/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return null;
    }

    // Send logged-out visitors to login and remember where they were headed —
    // a silent bounce to the homepage reads as a dead button.
    return user ? children : <Navigate to="/login" replace state={{ from: location }} />;
}
